import Vue from 'vue';

const START_TAB = 'tab-0';
const SELECT_TAB = 'tab-1';
const CONFIRM_TAB = 'tab-2';
const START_PROGRESS = 33;
const SELECT_PROGRESS = 67;
const CONFIRM_PROGRESS = 100;
const CLOSE_CITY = 'Малиновка';
const SEARCH_TITLE = 1;
const SBERBANK_MULTIPLY = 100;
const SBERBANK_SUCCESS_CODE = 0;
const SBERBANK_NEW_STATUS = 0;
const SBERBANK_SUCCESS_STATUS = 2;

const YOOKASSA_STATUS_REGISTERED = 0; // заказ зарегистрирован, не оплачен
const YOOKASSA_STATUS_PAYED = 2; // заказ оплачен
const YOOKASSA_STATUS_CANCELLED = 3; //платеж отменен или отклонен, причина указывается в поле comment

const state = {
    streets: [],
    houses: [],
    streetId: null,
    houseId: null,
    flat: '',
    contractTitle: '',
    contractFio: '',
    contracts: [],
    summa: '',
    remember: false,
    step: START_TAB,
    searchType: 1,
    orderId: '',
    yookassaWidgetToken: '',
    yookassaOrderId: '',
    yookassaOrderMerchant: '',
    status: 0,
    message: '',
    dateProcess: '',
    progress: START_PROGRESS,
    returnUrl: ''
};

const mutations = {
    changePaymentParams(state, items) {
        state = Object.assign(state, items)
    },
    setConnectBlank(state) {
        state.streetId = null;
        state.houseId = null;
        state.flat = '';
        state.summa = '';
        state.contractTitle = '';
        state.contractFio = '';
        state.step = START_TAB;
        state.searchType = 1;
        state.orderId = '';
        state.yookassaWidgetToken = '';
        state.yookassaOrderId = '';
        state.yookassaOrderMerchant = '';
        state.status = 0;
        state.message = '';
        state.dateProcess = '';
        state.progress = START_PROGRESS;
        state.returnUrl = '';
    }
};

const getters = {
    getPaymentStreetId: state => state.streetId,
    getPaymentHouseId: state => state.houseId,
    getPaymentFlat: state => state.flat,
    getPaymentContracts: state => {
        return state.contracts.sort(function (a, b) {
            if (a.status < b.status)
                return -1;
            else
                return 1;
        })
    },
    getPaymentContractTitle: state => state.contractTitle,
    getPaymentRemember: state => state.remember,
    getPaymentDateProcess: state => state.dateProcess,
    getPaymentStep: state => state.step,
    getPaymentSearchType: state => state.searchType,
    getPaymentSumma: state => state.summa,
    getPaymentContractFio: state => state.contractFio,
    getPaymentStreets: state => {
        let streets = [];
        state.streets.forEach(street => {
            if (street.city !== CLOSE_CITY)
                streets.push({ value: street.id, text: street.city + ', ' + street.street });
        });
        return streets;
    },
    getPaymentHouses: state => {
        let filterHouses = [];
        state.houses.forEach(house => {
            if (state.streetId === house.street_id)
                filterHouses.push({ value: house.id, text: house.house });
        });
        return filterHouses;
    },
    getPaymentStatus: state => state.status,
    getPaymentMessage: state => state.message,
    getPaymentProgress: state => state.progress,
    getPaymentYookassaWidgetToken: state => state.yookassaWidgetToken,
    getPaymentYookassaOrderId: state => state.yookassaOrderId,
    getPaymentYookassaOrderMerchant: state => state.yookassaOrderMerchant,
    getPaymentReturnUrl: state => state.returnUrl,
};

const actions = {
    changePayment({ commit }, items) {
        commit('changePaymentParams', items);
    },
    setPaymentStreets({ commit }) {
        commit('createProcess', 'paymentStreets');
        Vue.http.get(this.getters.getApiUrl + 'v1/streets?sort=city,street').then(response => {
            commit('changePaymentParams', { streets: response.data });
            commit('setProcessSuccess', 'paymentStreets');
        }, response => {
            commit('setProcessFailed', { id: 'paymentStreets', message: response.body.message });
        });
    },
    setPaymentHouses({ commit }) {
        commit('createProcess', 'paymentHouses');
        Vue.http.get(this.getters.getApiUrl + 'v1/houses?sort=house').then(response => {
            commit('changePaymentParams', { houses: response.data });
            commit('setProcessSuccess', 'paymentHouses');
        }, response => {
            commit('changeConnectParams', { houses: [], lastError: response.body.message });
            commit('setProcessFailed', { id: 'paymentHouses', message: response.body.message });
        });
    },
    setPaymentContacts({ commit }) {
        commit('destroyProcess', 'paymentGetContracts');
        commit('createProcess', 'paymentGetContracts');
        let params = {
            'title': state.contractTitle,
        };
        Vue.http.post(this.getters.getApiUrl + 'v1/contracts/id-by-title', params).then(response => {
            if (response.data.title !== undefined) {
                let contract = response.data;
                commit('changePaymentParams', {
                    step: CONFIRM_TAB,
                    contractTitle: contract.title,
                    progress: CONFIRM_PROGRESS
                });
                commit('setProcessSuccess', 'paymentGetContracts');
            } else {
                commit('setProcessFailed', {
                    id: 'paymentGetContracts',
                    message: 'Договор по указанному номеру не найден.'
                });
                setTimeout(function () {
                    commit('destroyProcess', 'paymentGetContracts');
                }, 6000);
            }
        }, response => {
            commit('setProcessFailed', { id: 'paymentGetContracts', message: response.body.message, code: response.body.code });
        });
    },
    setPaymentOrder({ commit }) {
        commit('destroyProcess', 'paymentOrder');
        commit('createProcess', 'paymentOrder');
        let item = {
            contract_title: state.contractTitle,
            summa: state.summa,
        };
        let url = this.getters.getApiUrl + 'v1/payments/add'; //Sber
        // let url = this.getters.getApiUrl + 'v1/pays/addpayment'; // Tinkoff
        Vue.http.post(url, item).then(response => {
            commit('setProcessSuccess', 'paymentOrder');
            commit('changePaymentParams', { orderId: response.data.orderId });
            window.location.href = response.data.formUrl; //Sber
            // window.location.href = response.data.payment_url; // Tinkoff
        }, response => {
            commit('setProcessFailed', { id: 'paymentOrder', message: response.body.message, code: response.body.code });
            if (response.body.code === 302) {
                setTimeout(() => {
                    window.location = "https://mycentra.ru/#/payments/stepper";
                }, 1000);
            }
        });
    },
    setPaymentOrderYookassa({ commit }) {
        commit('destroyProcess', 'paymentOrderYookassa');
        commit('createProcess', 'paymentOrderYookassa');
        let params = {
            contract_title: state.contractTitle,
            summa: state.summa,
            confirmation: 'embedded',
            save_payment: 1
        };
        let url = this.getters.getApiUrl + 'v1/payments/add-yookassa';
        Vue.http.post(url, params).then(response => {
            commit('setProcessSuccess', 'paymentOrderYookassa');
            commit('changePaymentParams', { yookassaOrderId: response.body.data.orderId });
            commit('changePaymentParams', { yookassaWidgetToken: response.body.data.token });
            commit('changePaymentParams', { returnUrl: response.body.data.returnUrl });
        }, response => {
            commit('setProcessFailed', { id: 'paymentOrderYookassa', message: 'При создании платежа что-то пошло не так. Повторите попытку позднее' });
        });
    },
    setPaymentCheckYookassa({ commit }) {
        commit('destroyProcess', 'paymentOrderYookassa');
        commit('destroyProcess', 'paymentCheck');
        commit('createProcess', 'paymentCheck');
        let item = {
            order_id: state.yookassaOrderId,
            merchant: state.yookassaOrderMerchant,
        };
        let url = this.getters.getApiUrl + 'v1/payments/check-yookassa';
        Vue.http.post(url, item).then(response => {
            if (response.body.success) {
                let data = response.body.data;
                commit('changePaymentParams', {
                    summa: data.summa,
                    contractTitle: data.contractTitle,
                    dateProcess: data.processedAt,
                    status: data.status,
                });
                switch (data.status) {
                    // заказ зарегистрирован, не оплачен
                    case YOOKASSA_STATUS_REGISTERED:
                        commit('setProcessFailed', { id: 'paymentCheck', message: 'Платеж ожидает оплаты.' });
                        break;
                    // заказ оплачен
                    case YOOKASSA_STATUS_PAYED:
                        if (data.transactionId) {
                            // если платеж проведен в биллинге
                            commit('setProcessSuccess', 'paymentCheck');
                        }
                        else {
                            commit('setProcessFailed', { id: 'paymentCheck', message: '' });
                        }
                        break;
                    //платеж отменен или отклонен, причина указывается в поле comment
                    case YOOKASSA_STATUS_CANCELLED:
                        commit('setProcessFailed', { id: 'paymentCheck', message: 'Платеж отменен или отклонен. Причина: ' + data.comment });
                        break;
                }
            }
            else {
                commit('setProcessFailed', { id: 'paymentCheck', message: 'Платеж отклонен. Свяжитесь с нашей службой технической поддержки по телефону +7(3843)756-000' });
            }
        }, response => {
            commit('setProcessFailed', { id: 'paymentCheck', message: 'При проверке платежа возникла ошибка. Повторите попытку позднее' });
        });
    },
    setPaymentCheck({ commit }) {
        commit('destroyProcess', 'paymentCheck');
        commit('createProcess', 'paymentCheck');
        let item = {
            order_id: state.orderId,
        };
        let url = this.getters.getApiUrl + 'v1/payments/check';
        Vue.http.post(url, item).then(response => {
            if (response.data.status === SBERBANK_SUCCESS_STATUS && response.data.transaction_id !== undefined) {
                commit('setProcessSuccess', 'paymentCheck');
                commit('changePaymentParams', {
                    summa: (response.data.summa / SBERBANK_MULTIPLY),
                    contractTitle: response.data.contract_title,
                    dateProcess: response.data.date_process,
                    status: response.data.status,

                });
            } else if (response.data.status === SBERBANK_NEW_STATUS) {
                commit('setProcessFailed', { id: 'paymentCheck', message: 'Платеж ожидает оплаты в системе банка.' });
                commit('changePaymentParams', {
                    summa: (response.data.summa / SBERBANK_MULTIPLY),
                    contractTitle: response.data.contract_title,
                    dateProcess: response.data.date_process,
                    status: response.data.status,
                });
            } else if (response.data.status !== SBERBANK_SUCCESS_CODE) {
                commit('setProcessFailed', {
                    id: 'paymentCheck',
                    message: 'Платеж отклонен терминалом банка. Попробуйте повторить платеж, перепроверив вводимые реквизиты.'
                });
                commit('changePaymentParams', {
                    summa: (response.data.summa / SBERBANK_MULTIPLY),
                    contractTitle: response.data.contract_title,
                    dateProcess: response.data.date_process,
                    status: response.data.status,
                });
            } else {
                commit('changePaymentParams', {
                    summa: (response.data.summa / SBERBANK_MULTIPLY),
                    contractTitle: response.data.contract_title,
                    dateProcess: response.data.date_process,
                    status: response.data.status,
                });
                commit('setProcessFailed', {
                    id: 'paymentCheck',
                    message: 'Платеж отклонен. Свяжитесь с нашей службой технической поддержки по телефону +7(3843)756-000'
                });
            }
        }, response => {
            commit('setProcessFailed', { id: 'paymentCheck', message: response.body.message });
        });
    },
    setPaymentBlank({ commit }) {
        commit('setPaymentBlank')
    },
    setPaymentStreetId({ commit }, id) {
        commit('changePaymentParams', { streetId: id });
        commit('changePaymentParams', { houseId: null });
    },
    setPaymentHouseId({ commit }, id) {
        commit('changePaymentParams', { houseId: id });
    },
    setPaymentFlat({ commit }, flat) {
        commit('changePaymentParams', { flat: flat });
    },
    setPaymentContractTitle({ commit }, title) {
        commit('changePaymentParams', { contractTitle: title });
    },
    setPaymentSumma({ commit }, value) {
        commit('changePaymentParams', { summa: value });
    },
    setPaymentContractFio({ commit }, value) {
        commit('changePaymentParams', { contractFio: value });
    },
    setPaymentRemember({ commit }, value) {
        commit('changePaymentParams', { remember: value });
    },
    setPaymentStep({ commit }, value) {
        commit('destroyProcess', 'paymentGetContracts');
        if (value === START_TAB)
            commit('changePaymentParams', { step: value, progress: START_PROGRESS });
        if (value === SELECT_TAB)
            commit('changePaymentParams', { step: value, progress: SELECT_PROGRESS });
        if (value === CONFIRM_TAB)
            commit('changePaymentParams', { step: value, progress: CONFIRM_PROGRESS });

    },
    setPaymentSearchType({ commit }, value) {
        commit('changePaymentParams', { searchType: value });
    },
    setPaymentOrderId({ commit }, value) {
        commit('changePaymentParams', { orderId: value });
    },
    setPaymentYookassaOrderId({ commit }, value) {
        commit('changePaymentParams', { yookassaOrderId: value });
    },
    setPaymentYookassaOrderMerchant({ commit }, value) {
        commit('changePaymentParams', { yookassaOrderMerchant: value });
    },
};

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/payment.js